import { render, staticRenderFns } from "./RemoveMember.vue?vue&type=template&id=fad80592&scoped=true"
import script from "./RemoveMember.vue?vue&type=script&lang=js"
export * from "./RemoveMember.vue?vue&type=script&lang=js"
import style0 from "./RemoveMember.vue?vue&type=style&index=0&id=fad80592&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad80592",
  null
  
)

export default component.exports